import { render, staticRenderFns } from "./AdminDocuments.vue?vue&type=template&id=57c8a74c&scoped=true"
import script from "./AdminDocuments.vue?vue&type=script&lang=ts"
export * from "./AdminDocuments.vue?vue&type=script&lang=ts"
import style0 from "./AdminDocuments.vue?vue&type=style&index=0&id=57c8a74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c8a74c",
  null
  
)

export default component.exports